// extracted by mini-css-extract-plugin
export default {"trade-count":"_2fiSR","tradeCount":"_2fiSR"};